import { FC, useState } from 'react';
import { Box, Svg, Tab, Tabs } from '@hopskipdrive/react-components';
import styled from 'styled-components';

import { variables } from '../../../../shared/components/variables';
import { ErrorBoundary } from '../../../../shared/utils/errorReporting/ErrorBoundary';
import { InfoNavContent } from '..';

import { Events, SkeletonEvents } from './Events';
import { MessagesAndCalls, SkeletonMessagesAndCalls } from './MessagesAndCalls';
import { RoAndAdjustedEarnings } from './RoAndAdjustedEarnings';

const MORE_TABS = {
  messagesAndCalls: 'messagesAndCalls',
  roAndAdjustedEarnings: 'roAndAdjustedEarnings',
  events: 'events',
  adminLink: 'adminLink',
};

interface MoreTabProps {
  adminUrl: string;
  rideSlug: string;
  timeZone: string;
}

export const MoreTab: FC<MoreTabProps> = ({ adminUrl, rideSlug, timeZone }) => {
  const [selectedTab, setSelectedTab] = useState<string>();

  return (
    <>
      <Box
        style={{
          borderTop: `1px solid ${variables.colorTokens.primary.borderDark}`,
          background: variables.colorTokens.tonal.light,
          width: '100%',
          padding: '6px',
          gap: '16px',
        }}
      >
        <Tabs
          value={selectedTab || false}
          sx={{
            pointerEvents: 'all',
            '& .MuiTabs-flexContainer': {
              gap: '16px',
            },
          }}
        >
          <StyledTab
            label={<IconLabel icon="message-contact" label="Messages and Calls" />}
            value={MORE_TABS.messagesAndCalls}
            onClick={() => setSelectedTab(MORE_TABS.messagesAndCalls)}
          />
          <StyledTab
            label={<IconLabel icon="monetization-on-rounded" label="RO and Adjusted Earning" />}
            value={MORE_TABS.roAndAdjustedEarnings}
            onClick={() => setSelectedTab(MORE_TABS.roAndAdjustedEarnings)}
          />
          <StyledTab
            label={<IconLabel icon="timeline-rounded" label="Events" />}
            value={MORE_TABS.events}
            onClick={() => setSelectedTab(MORE_TABS.events)}
          />
          <StyledTab
            label={<IconLabel icon="open-new" label="Admin" />}
            onClick={() => window.open(adminUrl, '_blank')}
          />
        </Tabs>
      </Box>
      {selectedTab === MORE_TABS.messagesAndCalls && (
        <InfoNavContent>
          <ErrorBoundary FallbackComponent={SkeletonMessagesAndCalls}>
            <MessagesAndCalls rideSlug={rideSlug} timeZone={timeZone} />
          </ErrorBoundary>
        </InfoNavContent>
      )}
      {selectedTab === MORE_TABS.roAndAdjustedEarnings && (
        <InfoNavContent>
          <RoAndAdjustedEarnings adminUrl={adminUrl} />
        </InfoNavContent>
      )}
      {selectedTab === MORE_TABS.events && (
        <InfoNavContent>
          <ErrorBoundary FallbackComponent={SkeletonEvents}>
            <Events rideSlug={rideSlug} timeZone={timeZone} />
          </ErrorBoundary>
        </InfoNavContent>
      )}
    </>
  );
};

const IconLabel = ({ icon, label }) => (
  <Box display="flex" alignItems="center" flexDirection="column">
    <Svg icon={icon} />
    <Box>{label}</Box>
  </Box>
);

const StyledTab = styled(Tab)`
  height: 46px;
  min-height: 33px;
`;
